import { makeStyles } from '@material-ui/core';
import { MDSDivider, MDSTypography } from '@marqvision/mds-v2';
import { SettingsProtocolsGetProfileResponse } from '~/swagger/data-contracts';
import { attachPmmS3BaseUrl } from '../@utils';

const useStyles = makeStyles({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  space: {
    width: '100%',
    height: '8px',
  },
  paragraph: {
    // padding: '8px 0',
  },
  link: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  item: {
    display: 'flex',
    '& > p': {
      marginLeft: '8px',
      width: '24px',
    },
    '& > p:last-child': {
      flex: 1,
      marginLeft: '-12px',
    },
  },
  video: {
    borderRadius: '8px',
    backgroundColor: '#000',
    width: '640px',
    height: '391px',
    overflow: 'hidden',
  },
  actions: {
    padding: '16px 20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});
type Props = {
  userProfile: SettingsProtocolsGetProfileResponse;
};
export const ContentEN = (props: Props) => {
  const classes = useStyles();
  const { userProfile } = props;

  return (
    <div className={classes.layout}>
      <MDSTypography variant="T20" weight="bold">
        Marq AI: Your New, Unified Dashboard
      </MDSTypography>

      <div style={{ padding: '8px 0' }}>
        <MDSDivider orientation="horizontal" />
      </div>

      <div className={classes.list}>
        <div className={classes.paragraph}>
          <MDSTypography variant="T14">
            Hi {userProfile.first_name} {userProfile.last_name}
          </MDSTypography>
        </div>
        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            Today, we're introducing the new and improved Marq AI dashboard. Here, you will find that your data and the
            features from the previous Marq Content dashboard have been migrated, giving you a unified view of your
            entire workflow.
          </MDSTypography>
        </div>

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography variant="T16" weight="medium">
            Channel-based Dashboard
          </MDSTypography>
        </div>
        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            The biggest update is our newly re-designed dashboard, which now organizes all your listings by channels to
            align with how you manage your digital presence. Now, you have one central place to view infringement
            activity, whether it’s website content, social media, domain names, or marketplaces.
          </MDSTypography>
        </div>
        <img src={attachPmmS3BaseUrl('241219-pmm-review-needed.png')} alt="review-needed" />

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography variant="T16" weight="medium">
            The New ‘Home’ Tab
          </MDSTypography>
        </div>
        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            Your new command center will be the ‘Home’ tab, which allows you to track ongoing tasks at a glance, submit
            new requests (report, retract, add to whitelist, and change assets), and access performance review insights
            shared by your Customer Success Manager.
          </MDSTypography>
        </div>
        <img src={attachPmmS3BaseUrl('250107-pmm-the-new-home-tab.png')} alt="smart-rules" />

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            If you have any questions or feedback, please feel free to reach out to your customer success manager!
          </MDSTypography>
        </div>

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography as="span" wordBreak="keep-all" variant="T14">
            Want to share your thoughts with us?
          </MDSTypography>{' '}
          <MDSTypography
            color="color/content/primary/default/normal"
            as="a"
            href={'https://forms.gle/UA2qHFzYrP9BFQy56'}
            target="_blank"
            wordBreak="keep-all"
            variant="T14"
          >
            Fill out this quick 1-minute survey to let us know!
          </MDSTypography>
        </div>
      </div>
    </div>
  );
};
